import { Button }                  from '@chakra-ui/react';
import { Dispatch }                from 'react';
import { FuseResult }              from 'fuse.js';
import { Link }                    from 'react-router-dom';
import { SearchItem }              from '@/hooks/useSearch';
import { SetStateAction }          from 'react';
import { Stack }                   from '@chakra-ui/react';
import { SystemStyleObject }       from '@chakra-ui/react';
import { useLocation }             from 'react-router-dom';
import useMenu                     from '@/hooks/useMenu';

interface INavigationMenuProps {
    setOpen?: Dispatch<SetStateAction<boolean>>;
    searchResults?: FuseResult<SearchItem>[];
}

const NavigationMenu = (props: INavigationMenuProps) => {
    const location = useLocation();
    const { setOpen, searchResults } = props;
    const { MENU_ITEMS } = useMenu();

    const filteredMenuItems = MENU_ITEMS.filter(menuItem => {
        if (!searchResults || searchResults.length === 0) {
            return true;
        } else {
            return searchResults.map(searchResult => searchResult.item.to).includes(menuItem.to);
        }
    })

    return (
        <Stack 
            {...styles.container.base}
            direction="column"
            lg={styles.container.lg}
        >
            {
                filteredMenuItems.map(item => {
                    const isSelected = location.pathname === item.to;
                    return (
                        <Link 
                            key={item.label} 
                            state={{ from: location }}
                            to={item.to}
                        >
                            <Button 
                                variant="ghost"
                                onClick={() => {
                                    if (setOpen) {
                                        setOpen(false);
                                    }
                                }}
                                bg={{ base: "unset", lg: isSelected ? "beigeLight" : "unset" }}
                                color={isSelected ? 'black' : 'rgba(0, 0, 0, 0.5)'}
                                paddingLeft={{ base: 0, lg: "10px" }}
                                justifyContent="flex-start"
                                width="100%"
                                _hover={{ bg: "beigeLight" }}
                            >
                                {item.icon}
                                {item.label}
                            </Button>
                        </Link>
                    )
                })
            }
        </Stack>
    )
}

export default NavigationMenu;

const styles: {
	[key: string]: {
		[key: string]: SystemStyleObject
	}
} = {
	container: {
		base: {
            bg: "white",
            height: "100%",
		    paddingLeft: 0,
            paddingTop: 0,
		},
		lg: {
		    paddingLeft: "20px",
            paddingRight: 5,
            paddingTop: 7,
		}
	}
};